import { render, staticRenderFns } from "./OrderDispatchDialogue.vue?vue&type=template&id=5df43117&"
import script from "./OrderDispatchDialogue.vue?vue&type=script&lang=ts&"
export * from "./OrderDispatchDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports